import * as React from 'react';
import { formatBytes } from '../../Hooks/bytesToMB';
import { useDropzone, FileWithPath } from 'react-dropzone';

import './CreateCollection.scss';
import useClickOutside from '../../Hooks/useClickOutside';
export interface ICreateCollectionProps {
}

export function CreateCollection(props: ICreateCollectionProps) {

    // 1st Drag and drop functionality------------------
    const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
        accept: 'image/gif,image/png,image/webp,video/mp4,video/mp3',
        maxSize: 100000000,
    });
    const files = acceptedFiles.map((file: any) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));











    return (
        <div className="
        pt-[64px]
        sm:max-w-[570px] sm:pt-[80px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px]
        mx-auto xs:mt-6 sm:mt-10 md:mt-24 pb-28 md:pb-24 px-4 create_collection_main_box">
            <div className="lg:w-9/12 xl:w-7/12 text-left">
                <h1 className="xs:text-2xl xl:text-3xl font-bold text-cusBlack dark:text-white text-left">Create a Collection</h1>


                <div className="text-left mt-8">
                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Logo image</h4>
                    <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-1 w-9/12">his image will also be used for navigation. 350 x 350 recommended</p>


                    <div {...getRootProps({ className: 'logoImageDropdown inline-block mt-6' })}>
                        <input {...getInputProps()} />
                        <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] rounded-full w-36 h-36 flex justify-center items-center">

                            <button
                                className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black text-cusLightLink dark:text-cusLink xs:px-3 sm:px-4 xs:py-1 sm:py-2 rounded-full xs:text-xs sm:text-sm">
                                Choose file
                            </button>
                        </div>
                    </div>

                    <div className="mt-2">
                        {files.length !== 0
                            ? <p className="text-white xs:text-xxs sm:text-base">Your File: {files}</p>
                            : fileRejections.length !== 0 &&
                            <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                        }
                    </div>
                </div>


                <div className="text-left mt-8">
                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Featured image</h4>
                    <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-1 w-9/12">This image will be used for featuring your collection on the homepage, category pages, or other promotional areas of OpenSea. 600 x 400 recommended.</p>


                    <div {...getRootProps({ className: 'featuredImageDropdown mt-8' })}>
                        <input {...getInputProps()} />
                        <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] py-10 p-3 mt-3 rounded-xl text-center">
                            {files.length !== 0
                                ? <p className="text-white mb-2 xs:text-xxs sm:text-base">Your File: {files}</p>
                                : fileRejections.length !== 0 &&
                                <p className="text-red-500 mb-2 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                            }
                            <button
                                className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-base">
                                Choose file
                            </button>
                        </div>
                    </div>
                </div>

                <div className="text-left mt-8">
                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Banner image</h4>
                    <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-1 w-9/12">This image will appear at the top of your collection page. Avoid including too much text in this banner image, as the dimensions change on different devices. 1400 x 400 recommended.</p>


                    <div {...getRootProps({ className: 'featuredImageDropdown mt-8' })}>
                        <input {...getInputProps()} />
                        <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] py-10 p-3 mt-3 rounded-xl text-center">
                            {files.length !== 0
                                ? <p className="text-white mb-2 xs:text-xxs sm:text-base">Your File: {files}</p>
                                : fileRejections.length !== 0 &&
                                <p className="text-red-500 mb-2 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                            }
                            <button
                                className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-base">
                                Choose file
                            </button>
                        </div>
                    </div>
                </div>


                <div className="mt-8">
                    <h4 className="w-11/12 text-left text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Display name</h4>
                    <input type="email" name="" id="" placeholder='Enter your display name'
                        className="lightBlueBg p-6 rounded-xl mt-3 relative duration-300
                            form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                </div>

                <div className="mt-8">
                    <h4 className="w-11/12 text-left text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Display name</h4>
                    <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite text-left mt-1 w-9/12">Customize your URL on UNC. Must only contain lowercase letters, numbers, and hyphens.</p>
                    <input type="email" name="" id="" placeholder='https://.unsea.io/collection/'
                        className="lightBlueBg p-6 rounded-xl mt-3 relative duration-300
                            form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                </div>

                <div className="mt-8">
                    <h4 className="w-11/12 text-left text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Personal site or portfolio</h4>
                    <input type="email" name="" id="" placeholder='https://'
                        className="lightBlueBg p-6 rounded-xl mt-3 relative duration-300
                            form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                </div>

                <div className="add_more_btn_box mt-6">
                    <button className="lightBlueBg py-3 w-full rounded-lg add_more_btn text-cusBlack dark:text-white">
                        + Add Link
                    </button>
                </div>



                <div className="mt-8">
                    <h4 className="text-cusBlack dark:text-white font-extrabold dark:font-medium text-lg">Creator Earnings</h4>
                    <p className="xs:text-xs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-1 xs:w-10/12 lg:w-8/12">Collect a fee when a user re-sells an item you originally created. This is deducted from the final sale price and paid monthly to a payout address of your choosing. <a href="" className="text-black font-medium dark:text-cusLink">Learn more about creator earnings.</a></p>
                </div>


                <div className="mt-8">
                    <h4 className="w-11/12 text-left text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Percentage fee</h4>
                    <input type="email" name="" id="" placeholder='e.g. 25%'
                        className="lightBlueBg p-6 rounded-xl mt-3 relative duration-300
                            form-input transition-all w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                </div>


                <div className="mt-8">
                    <h4 className="w-11/12 text-left text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Payment tokens</h4>
                    <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite text-left mt-1 w-9/12">These tokens can be used to buy and sell your items.</p>

                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-5 gap-y-3 mt-4 block_chain_options">
                        <input type="radio" name="tookens" id="tokensETH" className="hidden" />
                        <div className="block_chain_option">
                            <label htmlFor="tokensETH" className="lightBlueBg xs:p-2 sm:p-4 xs:rounded-md sm:rounded-xl flex justify-start items-center cursor-pointer ">
                                <div className="ethereum xs:w-8 xs:h-8 sm:w-16 sm:h-16 flex justify-center items-center rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-3.5 sm:w-auto" width="25.398" height="35.235" viewBox="0 0 16.398 26.235">
                                        <g id="Group_1488" data-name="Group 1488" transform="translate(0 0)">
                                            <path id="Path" d="M632.2,207.1v9.7l8.2,3.663Z" transform="translate(-624.003 -207.1)" fill="rgba(255,255,255,0.6)" />
                                            <path id="Path_1_" d="M469,207.1l-8.2,13.361L469,216.8Z" transform="translate(-460.8 -207.1)" fill="#fff" />
                                            <path id="Path_2_" d="M632.2,523.158v6.59l8.2-11.348Z" transform="translate(-624.003 -503.513)" fill="rgba(255,255,255,0.6)" />
                                            <path id="Path_3_" d="M469,529.748v-6.59l-8.2-4.758Z" transform="translate(-460.8 -503.513)" fill="#fff" />
                                            <path id="Path_4_" d="M632.2,418.321l8.2-4.758-8.2-3.663Z" transform="translate(-624.003 -400.202)" fill="rgba(255,255,255,0.2)" />
                                            <path id="Path_5_" d="M460.8,413.563l8.2,4.758V409.9Z" transform="translate(-460.8 -400.202)" fill="rgba(255,255,255,0.6)" />
                                        </g>
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h4 className="xs:text-base sm:text-xl font-black dark:font-semibold text-cusBlack dark:text-white">ETH</h4>
                                    <h4 className="xs:text-xs sm:text-base font-black dark:font-semibold text-cusBlack dark:text-white">Ethereum</h4>
                                </div>
                            </label>
                        </div>

                        <input type="radio" name="tookens" id="tokensWETH" className="hidden" />
                        <div className="block_chain_option">
                            <label htmlFor="tokensWETH" className="lightBlueBg xs:p-2 sm:p-4 xs:rounded-md sm:rounded-xl flex justify-start items-center cursor-pointer ">
                                <div className="ethereum xs:w-8 xs:h-8 sm:w-16 sm:h-16 flex justify-center items-center rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="xs:w-3.5 sm:w-auto" width="25.398" height="35.235" viewBox="0 0 16.398 26.235">
                                        <g id="Group_1488" data-name="Group 1488" transform="translate(0 0)">
                                            <path id="Path" d="M632.2,207.1v9.7l8.2,3.663Z" transform="translate(-624.003 -207.1)" fill="rgba(255,255,255,0.6)" />
                                            <path id="Path_1_" d="M469,207.1l-8.2,13.361L469,216.8Z" transform="translate(-460.8 -207.1)" fill="#fff" />
                                            <path id="Path_2_" d="M632.2,523.158v6.59l8.2-11.348Z" transform="translate(-624.003 -503.513)" fill="rgba(255,255,255,0.6)" />
                                            <path id="Path_3_" d="M469,529.748v-6.59l-8.2-4.758Z" transform="translate(-460.8 -503.513)" fill="#fff" />
                                            <path id="Path_4_" d="M632.2,418.321l8.2-4.758-8.2-3.663Z" transform="translate(-624.003 -400.202)" fill="rgba(255,255,255,0.2)" />
                                            <path id="Path_5_" d="M460.8,413.563l8.2,4.758V409.9Z" transform="translate(-460.8 -400.202)" fill="rgba(255,255,255,0.6)" />
                                        </g>
                                    </svg>
                                </div>
                                <div className="ml-3">
                                    <h4 className="xs:text-base sm:text-xl font-black dark:font-semibold text-cusBlack dark:text-white">WETH</h4>
                                    <h4 className="xs:text-xs sm:text-base font-black dark:font-semibold text-cusBlack dark:text-white">Ethereum</h4>
                                </div>
                            </label>
                        </div>

                    </div>
                </div>


                <div className="add_more_btn_box mt-6">
                    <button className="lightBlueBg py-3 w-full rounded-lg add_more_btn text-cusBlack dark:text-white">
                        + Add Tokens
                    </button>
                </div>




                <div className="mt-8 display_theme_box">
                    <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Display theme</h4>
                    <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-1 w-9/12">Change how your items are shown.</p>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-4 mt-5">

                        <input type="radio" name="displayTheme" id="padded" className="hidden" />
                        <label htmlFor="padded" className="display_theme_options cursor-pointer relative lightBlueBg p-4 rounded-lg">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="53.5" height="72.5" viewBox="0 0 53.5 72.5">
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="0.94" y1="0.063" x2="0.065" y2="0.922" gradientUnits="objectBoundingBox">
                                            <stop offset={0} stopColor="#e315e8" />
                                            <stop offset={1} stopColor="#ffd817" />
                                        </linearGradient>
                                    </defs>
                                    <rect id="Rectangle_1588" data-name="Rectangle 1588" width={52} height={71} rx={5} transform="translate(0.75 0.75)" fill="none" stroke="#3a3892" strokeWidth="1.5" />
                                    <path id="Path_1170" data-name="Path 1170" d="M0,0H24.96" transform="translate(8.55 48.13)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth="1.5" />
                                    <path id="Path_1171" data-name="Path 1171" d="M0,0H52" transform="translate(0.75 39.13)" fill="none" stroke="#3a3892" strokeLinecap="round" strokeWidth="1.5" />
                                    <line id="Line_86" data-name="Line 86" x2="12.48" transform="translate(8.55 54.37)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth="1.5" />
                                    <rect id="Rectangle_1589" data-name="Rectangle 1589" width="23.227" height="21.84" rx={2} transform="translate(14.79 9.07)" fill="url(#linear-gradient)" />
                                </svg>
                            </div>
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-base md:text-xl mt-4">Padded</h4>
                            <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2">Recommended for assets with transparent background</p>

                            <div className="w-4 h-4 border border-gray-500 diaplay_theme_checkbox rounded-sm absolute top-4 right-5">

                            </div>
                        </label>

                        <input type="radio" name="displayTheme" id="Contained" className="hidden" />
                        <label htmlFor="Contained" className="display_theme_options cursor-pointer relative lightBlueBg p-4 rounded-lg">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="53.5" height="72.5" viewBox="0 0 53.5 72.5">
                                    <g id="Group_1883" data-name="Group 1883" transform="translate(0.75 0.75)">
                                        <rect id="Rectangle_1588" data-name="Rectangle 1588" width={52} height={71} rx={5} fill="none" stroke="#3a3892" strokeWidth="1.5" />
                                        <rect id="Rectangle_1589" data-name="Rectangle 1589" width="36.707" height="38.38" transform="translate(7.8 0)" fill="#3f3d77" />
                                        <path id="Path_1170" data-name="Path 1170" d="M0,0H24.96" transform="translate(7.8 47.38)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth="1.5" />
                                        <line id="Line_86" data-name="Line 86" x2="12.48" transform="translate(7.8 53.62)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth="1.5" />
                                        <path id="Path_1171" data-name="Path 1171" d="M0,0H52" transform="translate(0 38.38)" fill="none" stroke="#3a3892" strokeLinecap="round" strokeWidth="1.5" />
                                        <rect id="Rectangle_1855" data-name="Rectangle 1855" width={52} height={71} rx={5} fill="none" stroke="#3a3892" strokeWidth="1.5" />
                                    </g>
                                </svg>
                            </div>
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-base md:text-xl mt-4">Contained</h4>
                            <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2">Recommended for assets that are not a 1:1 ratio</p>

                            <div className="w-4 h-4 border border-gray-500 diaplay_theme_checkbox rounded-sm absolute top-4 right-5">

                            </div>
                        </label>

                        <input type="radio" name="displayTheme" id="Covered" className="hidden" />
                        <label htmlFor="Covered" className="display_theme_options cursor-pointer relative lightBlueBg p-4 rounded-lg">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="53.5" height="72.5" viewBox="0 0 53.5 72.5">
                                    <g id="Group_1884" data-name="Group 1884" transform="translate(0.75 0.75)">
                                        <rect id="Rectangle_1588" data-name="Rectangle 1588" width={52} height={71} rx={5} fill="none" stroke="#3a3892" strokeWidth="1.5" />
                                        <rect id="Rectangle_1589" data-name="Rectangle 1589" width="52.307" height="38.38" transform="translate(0 0)" fill="#3f3d77" />
                                        <path id="Path_1170" data-name="Path 1170" d="M0,0H24.96" transform="translate(7.8 47.38)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth="1.5" />
                                        <line id="Line_86" data-name="Line 86" x2="12.48" transform="translate(7.8 53.62)" fill="none" stroke="#3f3d77" strokeLinecap="round" strokeWidth="1.5" />
                                        <path id="Path_1171" data-name="Path 1171" d="M0,0H52" transform="translate(0 38.38)" fill="none" stroke="#3a3892" strokeLinecap="round" strokeWidth="1.5" />
                                        <rect id="Rectangle_1855" data-name="Rectangle 1855" width={52} height={71} rx={5} fill="none" stroke="#3a3892" strokeWidth="1.5" />
                                    </g>
                                </svg>
                            </div>
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-base md:text-xl mt-4">Covered</h4>
                            <p className="xs:text-xxs sm:text-sm text-l-LightBlack dark:text-cusBlueWhite mt-2">Recommended for assets that can extend to the edge</p>

                            <div className="w-4 h-4 border border-gray-500 diaplay_theme_checkbox rounded-sm absolute top-4 right-5">

                            </div>
                        </label>
                    </div>
                </div>



                <div className="mt-8">
                    <div className="flex justify-between items-center">
                        <div>
                            <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-lg">Explicit & Sensitive Content</h4>
                            <div className="flex justify-start items-center">
                                <p className="xs:text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite mr-3">Set this item as explicit and sensitive content</p>
                                <div className="w-6 h-6 flex justify-center items-center rounded-full lightBlueBg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width={5} height={17} viewBox="0 0 5 17">
                                        <text id="Watch_the_Season_Fin" data-name="Watch the Season Fin" transform="translate(0 14)" fill="#656391" fontSize={16} fontFamily="TimesNewRomanPS-BoldItalicMT, Times New Roman" fontWeight={700} fontStyle="italic"><tspan x={0} y={0}>i</tspan></text>
                                    </svg>

                                </div>
                            </div>
                        </div>

                        <div className="flex items-center justify-center">
                            <label htmlFor="createCollectionExplicitContent" className="flex items-center cursor-pointer">
                                <div className="relative">
                                    <input type="checkbox" id="createCollectionExplicitContent" name="postOnActivity" className="sr-only" />
                                    <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                    <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                </div>
                            </label>
                        </div>
                    </div>
                </div>





                <button

                    className="xs:text-sm md:text-lg font-semibold text-white mt-8 xs:p-4 sm:p-6 xl:p-7 w-full rounded-xl  gradientBtn">
                    Create Collection
                </button>

            </div>
        </div>
    );
}
